import React from 'react';
import EditPencil from '../../assets/EditPencil';
import DeleteMenuIcon from '../../assets/DeleteMenuIcon';

export const INITIAL_EXERCISE_CATEGORY_FORM = () => ({
  name: '',
  beginnerUnlockScore: 0,
  intermediateUnlockScore: '',
  advanceUnlockScore: '',
  subtext: '',
  departmentIds: [],
});

export const INITIAL_EXERCISE_INFO = () => ({
  name: '',
  type: '',
  level: '',
  desc: '',
  timeLimit: '',
  userRole: '',
  botRole: '',
  botCharacter: '',
  overview: '',
  scenarioIntro: '',
  callTransfer: '',
  botIntro: '',
  goal: '',
  context: '',
  instruction: '',
  reportingParameters: [
    { name: '', description: '', instructions: [] },
    { name: '', description: '', instructions: [] },
    { name: '', description: '', instructions: [] },
  ],
  showTranscript: true,
});

export const INITIAL_OVERVIEW = () => ({
  text: '',
});

export const EXERCISE_LEVEL = [
  {
    id: 1,
    name: 'Beginner',
  },
  {
    id: 2,
    name: 'Intermediate',
  },
  {
    id: 3,
    name: 'Advanced',
  },
];

export const AI_EXERCISE_MENU_ITEMS = [
  {
    name: 'Edit Exercise',
    icon: <EditPencil fontSize="small" />,
  },
  {
    name: 'Delete Exercise',
    icon: <DeleteMenuIcon fontSize="small" />,
  },
];

export const TOOLTIP_MSG_INTERMEDIATE =
  'Enter the aggregate percentage score needed to unlock intermediate level. Example: If set to 50% and the beginner level has 2 exercises each totaling 30 points, users need 30 combined points (e.g., 25 + 5) to advance.';

export const TOOLTIP_MSG_ADVANCED =
  'Enter the aggregate percentage score needed to unlock advanced level. Example: If set to 50% and the intermediate level has 2 exercises each totaling 30 points, users need 30 combined points (e.g., 25 + 5) to advance.';

export const CONTENT_TYPE_ID = {
  ROCKED: 1,
  OEM: 2,
  PARTNER: 3,
};

export const CONTENT_TYPE = [
  {
    value: CONTENT_TYPE_ID.ROCKED,
    name: 'RockED',
  },
  {
    value: CONTENT_TYPE_ID.OEM,
    name: 'OEM',
  },
  {
    value: CONTENT_TYPE_ID.PARTNER,
    name: 'Partner',
  },
];

export const AI_EXERCISE_CUSTOM_ROLE = 'Custom Role';

export const AI_EXERCISE_ROLE_OPTIONS = [
  { department: 'Sales', role: 'Sales BDC' },
  { department: 'Sales', role: 'Sales Associate' },
  { department: 'Sales', role: 'Product Specialist' },
  { department: 'Sales', role: 'Delivery Specialist' },
  { department: 'Sales', role: 'Reception' },
  { department: 'Sales', role: 'Salesperson' },
  { department: 'Sales', role: 'Sales Consultant' },
  { department: 'Sales', role: 'Senior Sales Consultant' },
  { department: 'Sales', role: 'Sales Specialist' },
  { department: 'Sales', role: 'Associate' },
  { department: 'Sales', role: 'BDC Representative' },
  { department: 'Sales Leadership', role: 'GM' },
  { department: 'Sales Leadership', role: 'GSM' },
  { department: 'Sales Leadership', role: 'Sales Manager' },
  { department: 'Sales Leadership', role: 'Internet Manager' },
  { department: 'Sales Leadership', role: 'Performance Manager' },
  { department: 'Fixed Operations Leadership', role: 'Fixed Operations Director' },
  { department: 'Fixed Operations Leadership', role: 'Service Manager' },
  { department: 'Fixed Operations Leadership', role: 'Shop Foreman' },
  { department: 'Fixed Operations Leadership', role: 'Parts Manager' },
  { department: 'Fixed Operations Leadership', role: 'Collision Manager' },
  { department: 'Fixed Operations', role: 'Service Advisor' },
  { department: 'Fixed Operations', role: 'Technician' },
  { department: 'Fixed Operations', role: 'Porter' },
  { department: 'Fixed Operations', role: 'Parts Associate' },
  { department: 'Fixed Operations', role: 'Collision Advisor' },
  { department: 'Fixed Operations', role: 'Service BDC' },
  { department: 'Fixed Operations', role: 'Collision Customer Service' },
  { department: 'Fixed Operations', role: 'Collision Customer Service Representative' },
  { department: 'Fixed Operations', role: 'Estimator' },
  { department: 'F&I and Business Office', role: 'F&I Director' },
  { department: 'F&I and Business Office', role: 'Business Director' },
  { department: 'F&I and Business Office', role: 'F&I Manager' },
  { department: 'F&I and Business Office', role: 'Business Manager' },
  { department: 'F&I and Business Office', role: 'CFO' },
  { department: 'F&I and Business Office', role: 'Controller' },
  { department: 'F&I and Business Office', role: 'Business Office' },
  { department: 'F&I and Business Office', role: 'CNAC Representative' },
  { department: 'Executive and Admin', role: 'Dealer Principal' },
  { department: 'Executive and Admin', role: 'Owner' },
  { department: 'Executive and Admin', role: 'HR' },
  { department: 'Executive and Admin', role: 'Training' },
  { department: 'Executive and Admin', role: 'Admin' },
];

export const AI_EXERCISE_ROLE_DEPARTMENTS = [...new Set(AI_EXERCISE_ROLE_OPTIONS.map((option) => option.department))];
